import { FC, ReactNode, createElement } from 'react';

import {
    ApplianceContextProvider,
    DrawingShapeContextProvider,
    OptionalProductContextProvider,
    PricedProductsContextProvider,
    ProductDetailsContextProvider,
    ShapeContextProvider,
    ShapeTabContextProvider,
} from '.';

interface ComposeProvidersProps {
    providers: FC[];
    children?: ReactNode;
}

interface ContextProviderProps {
    children?: ReactNode;
}

const ComposeProviders = ({ providers, children }: ComposeProvidersProps) => (
    <>
        {providers.reduceRight((acc, ContextProvider) => {
            return createElement(ContextProvider, null, acc);
        }, children)}
    </>
);

export const ContextProvider = ({ children }: ContextProviderProps) => {
    const providers: FC[] = [
        ShapeContextProvider,
        DrawingShapeContextProvider,
        ShapeTabContextProvider,
        OptionalProductContextProvider,
        ApplianceContextProvider,
        ProductDetailsContextProvider,
        PricedProductsContextProvider,
    ];
    return <ComposeProviders providers={providers}>{children}</ComposeProviders>;
};
